import Breakpoints from "./Breakpoints.js";
class Accordion {
  constructor(selector, onlySP) {
    this.root = document.querySelector(selector);
    this.triggers = this.root.querySelectorAll('[data-accordion-trigger]');
    this.targets = this.root.querySelectorAll('[data-accordion-target]');
    this.onlySP = onlySP;
    this.breakpoints = new Breakpoints();
    this.isDesktop = this.breakpoints.up('md');
    this.#addEvent();
    this.#init();
  }
  #init() {
    if(this.onlySP && this.isDesktop.matches) {
      this.#allOpen()
    }
  }
  #addEvent() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.#toggle);
    });
    if(this.onlySP) {
      this.isDesktop.addEventListener('change', () => {
        if(this.isDesktop.matches) {
          this.#allOpen()
        } else {
          this.#allClose()
        }
      });
    }
  }
  #toggle(e) {
    const group = e.currentTarget.closest('[data-accordion-group]');
    const target = group.querySelector('[data-accordion-target]');
    if (group.getAttribute('aria-expanded') === 'false') {
      group.setAttribute('aria-expanded', 'true');
      target.setAttribute('aria-hidden', 'false');
    } else {
      group.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');
    }
  }
  #allOpen() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });
    this.targets.forEach((target) => {
      target.setAttribute('aria-hidden', 'false');
    });
  }
  #allClose() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.targets.forEach((target) => {
      target.setAttribute('aria-hidden', 'true');
    });
  }
}
export default Accordion;